var _defs, _style, _g, _g2, _g3, _g4, _g5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAicharges(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "185 25 525 460",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "grain",
    x: "-20%",
    y: "-20%",
    width: "140%",
    height: "140%"
  }, /*#__PURE__*/React.createElement("feTurbulence", {
    type: "fractalNoise",
    baseFrequency: 0.8,
    numOctaves: 3,
    result: "noise"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 7 -3",
    result: "contrastNoise"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic",
    in2: "contrastNoise",
    operator: "in"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "docClip"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 424,
    y: 140,
    width: 166,
    height: 212,
    rx: 24
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "cursorClip"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 530 320 L 655 355 L 632 390 L 685 448 L 642 475 L 590 416 L 555 448 Z"
  })))), _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n    .purple { fill: #6e72ee; }\n    .coin-edge { fill: #ffffff; }\n    .doc-bg { fill: #d8e1fa; }\n    .dark-element { fill: #20202e; }\n    .stroke-white { stroke: #ffffff; stroke-linecap: round; stroke-linejoin: round; fill: none; }\n  ")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "coin"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 284,
    cy: 130,
    r: 90,
    className: "coin-edge"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 300,
    cy: 122,
    r: 90,
    className: "purple"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(300, 122)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -2 -50 L 8 -50 L 8 50 L -2 50 Z",
    className: "dark-element"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 24 -24 C 24 -40 6 -42 -4 -42 C -24 -42 -27 -25 -27 -15 C -27 5 -5 12 8 16 C 22 20 28 26 28 36 C 28 48 18 56 -4 56 C -24 56 -31 43 -31 31 L -15 28 C -15 36 -9 42 -2 42 C 9 42 13 36 13 28 C 13 18 -1 13 -13 9 C -25 5 -31 -2 -31 -14 C -31 -29 -18 -56 5 -56 C 18 -56 38 -45 39 -22 Z",
    className: "dark-element"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "chevrons",
    strokeWidth: 7.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 268 255 L 305 290 L 268 325",
    className: "stroke-white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 310 255 L 347 290 L 310 325",
    className: "stroke-white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 352 255 L 389 290 L 352 325",
    className: "stroke-white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "document"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 424,
    y: 140,
    width: 166,
    height: 212,
    rx: 24,
    className: "doc-bg"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#docClip)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 545 250 Q 580 280 590 355 L 600 360 L 540 360 Z",
    className: "dark-element",
    filter: "url(#grain)",
    opacity: 0.85
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 420 310 Q 450 320 480 355 L 420 360 Z",
    className: "dark-element",
    filter: "url(#grain)",
    opacity: 0.85
  }), /*#__PURE__*/React.createElement("g", {
    className: "dark-element",
    opacity: 0.65
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 578,
    cy: 265,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 568,
    cy: 275,
    r: 2.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 583,
    cy: 282,
    r: 1.8
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 573,
    cy: 292,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 563,
    cy: 300,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 585,
    cy: 305,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 570,
    cy: 318,
    r: 2.8
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 580,
    cy: 328,
    r: 1.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 565,
    cy: 336,
    r: 2.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 435,
    cy: 338,
    r: 2.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 445,
    cy: 344,
    r: 1.8
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 458,
    cy: 348,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 438,
    cy: 328,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 448,
    cy: 334,
    r: 2
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M 454 180 L 560 180",
    stroke: "#20202e",
    strokeWidth: 4.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 495 214 L 560 214",
    stroke: "#20202e",
    strokeWidth: 4.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 452,
    y: 207,
    width: 44,
    height: 14,
    rx: 7,
    className: "dark-element"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 496 244 L 560 244",
    stroke: "#20202e",
    strokeWidth: 4.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 452,
    y: 237,
    width: 46,
    height: 14,
    rx: 7,
    className: "dark-element"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "checkmark"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 620 218 Q 632 278 640 286 Q 650 268 684 192",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 6.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "cursor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 530 320 L 655 355 L 632 390 L 685 448 L 642 475 L 590 416 L 555 448 Z",
    className: "purple"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cursorClip)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 540 400 L 700 370 L 700 500 L 540 500 Z",
    className: "dark-element",
    filter: "url(#grain)",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("g", {
    className: "dark-element",
    opacity: 0.75
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 645,
    cy: 450,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 660,
    cy: 440,
    r: 1.8
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 635,
    cy: 430,
    r: 2.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 620,
    cy: 420,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 650,
    cy: 415,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 600,
    cy: 410,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 575,
    cy: 435,
    r: 1.8
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 560,
    cy: 430,
    r: 2.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 625,
    cy: 455,
    r: 2
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAicharges);
export default __webpack_public_path__ + "static/media/aicharges.9239976dc514664bf19183052c2a7186.svg";
export { ForwardRef as ReactComponent };